module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZMAAAAECAYAAABLCNIuAAAACXBIWXMAAAsTAAALEwEAmpwYAAABCElEQVRYhe2VS5LDMAhEGyW5/0nmiClmg+wGIc2ksu23kQTNT3bZhp+3Y3LvsLV5czhqPslXzu7/023j11wvAObAM8yv0DwAPGL/jHWEfe7hwIBjkN8csORH8k+bkW36r7jwj+iT8xnrPeuNV6w+rm1xGXedEk95LPXnrfbyUy1Ltb33ozlfsV5y1Jxrr7MO9zVqXDPnaaZe5+e4Nv/aW9WuZ19zbXsqd0AzbO+7iWE/as1NXe4brN9p4y7Q+vpZpzjVszxbzQWr/XmahefDId91j/T+pzy1f2TyM7h74DhQ7eTvVr8N6Tk369LHx5w+4HvG3xIhhBDijH4mQgghvkY/EyGEEF/zC/AmlCR32IMhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/border.png
// module id = tZ2U
// module chunks = 15